import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EventEmitter } from 'events';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DialogData } from 'src/app/entities/dialogData';
import { AvisService } from 'src/app/services/avis.service';
import { SharedService } from 'src/app/services/sharedService';
import { TaxPayerService } from 'src/app/services/taxPayer.service';
import { UserService } from 'src/app/services/user.service';
import { DialogCommunicator } from '../dialog-communicator';
import { MergeUsers } from 'src/app/entities/mergeUsers';
import { TasDataSource } from 'src/app/services/tasGovTable.datasource';
import { InformationDialogComponent } from '../information-dialog/information-dialog.component';

@Component({
  selector: 'gov-merge-users-dialog',
  templateUrl: './merge-users-dialog.component.html',
  styleUrls: ['./merge-users-dialog.component.css']
})
export class MergeUsersDialogComponent extends DialogCommunicator implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['tin', 'name', 'action'];
  dataSource: TasDataSource;
  text: string
  emitter: EventEmitter
  fillMergeUsers: any
  currentUser: any
  selectedTin1: any = null; // main taxpayer to keep
  selectedTin2: any = null; // duplicate taxpayer to merge
  subscriptionMergeUsers
  loading = { inProgress: false, downloadInProgress: false }
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  filterObject: {};

  constructor(
    public dialogRef: MatDialogRef<MergeUsersDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: DialogData, 
    public sharedService: SharedService,
    public taxPayerService: TaxPayerService,
    public avisService: AvisService,
    public userService: UserService,
    public confirmationDialog: MatDialog) {
    super(dialogRef, sharedService)
    this.setConfirmationDialog(this.confirmationDialog)
  }

  async ngOnInit() {
    this.selectedTin1 = this.data
    this.dataSource = new TasDataSource(this.taxPayerService)
    this.userService.getCurrentUser().subscribe(user => {
      this.fillMergeUsers = new MergeUsers()
      this.fillMergeUsers.date = new Date()
      this.fillMergeUsers['class'] = 'MERGE'
      this.setEntity(this.fillMergeUsers);
      this.currentUser = user
    })
  }

  onSelectTIN2(taxpayer) {
    this.selectedTin2 = taxpayer;
  }

  public objectComparisonFunction = function (option, value): boolean {
    if (value)
      return option === value;
    return false;
  }

  advancedSearch(filter) {
    if (!this.filterObject) {
      this.filterObject = {}
    }
    let advF = [
      'tin',
      'name',
    ];
    advF.forEach((elem) => {
      if (!filter[elem] || filter[elem].length === 0) delete this.filterObject[elem];
    });
    this.filterObject = Object.assign({}, this.filterObject, filter);
    this.dataSource.emptyData()
    this.loading.inProgress = true
    this.dataSource.loadData(
      "tax-payers",
      '',
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.filterObject,
      this.loading
    );
  }
  reset() {
    this.filterObject = {};
  }

  ngAfterViewInit() {
    const interval = setInterval(() => {
      if (this.paginator && this.sort) {
        this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
        merge(this.sort.sortChange, this.paginator.page)
          .pipe(tap(() => this.loadTaxPayerData()))
          .subscribe();
        clearInterval(interval);
      }
    }, 100);
  }
  
  loadTaxPayerData() {
    this.dataSource.emptyData()
    this.loading.inProgress = true
    this.dataSource.loadData('tax-payers',
      '',
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize, this.filterObject, this.loading);
  }

  merge(action) {
    if (action !== 'MERGE') return;
    this.loading.inProgress = true;

    const mergeUsers = {
      tin1: this.selectedTin1.tin,
      tin2: this.selectedTin2.tin,
      municipalityId: this.data['municipality']['id'],
      municipalityName: this.data['municipality']['name'],
      companyName: this.data['name']
    }
  
    const saveMerge = {
      "type": 'MERGE',
      "tin": this.data['tin'],
      "companyName": this.data['name'],
      "municipalityId": this.data['municipality']['id'],
      "municipalityName": this.data['municipality']['name'],
      "details":{
        'deletedUserTin': this.selectedTin2.tin,
        'deletedUser': this.selectedTin2.name
        }
    };
  
    this.taxPayerService.saveNotificationData(saveMerge).subscribe({
      next: () => {
        this.taxPayerService.mergeUsers(mergeUsers).subscribe({
          next: () => {
            this.loading.inProgress = false;
            const dialogRefConf = this.dialog.open(InformationDialogComponent, {
              width: '500px',
              disableClose: true,
              data: { text: "DIALOG.MERGED_SUCCESSFULLY" }
            });
            dialogRefConf.afterClosed().subscribe(() => {
              this.dialogRef.close(true);
            });
          },
          error: (mergeError) => {
            this.loading.inProgress = false;
            console.error('Merge failed:', mergeError);
          }
        });
      },
      error: (notificationError) => {
        this.loading.inProgress = false;
        console.error('Failed to save notification:', notificationError);
      }
    });
  }
}
